// App name: Custom Elementor Accordion

const CustomAccordionApp = (function ($) {
  // init
  function init() {
    closeAccordionOnDefault();
    scrollToTopOfActiveTab();
    activeTabOnHash();
  }

  function closeAccordionOnDefault() {
    var delay = 100;
    setTimeout(function() {
      $('.elementor-tab-title').removeClass('elementor-active');
      $('.elementor-tab-content').css('display', 'none');
    }, delay);
  }

  function scrollToTopOfActiveTab() {
    let headerHeight = $('.header').outerHeight();

    $('.elementor-accordion .elementor-tab-title').on('click', function() {
      setTimeout(() => {
        let pos = $(this).offset().top;
        $("html, body").animate({
            scrollTop: pos - headerHeight - 10,
        }, 500);
        return false;
      }, 500);
    })
  }

  function activeTabOnHash() {
    setTimeout(function(){
      var current = window.location.hash;
      var current = current.split('#tab');
      if(current.length > 1 && $('.elementor-tab-title').filter('#elementor-tab-title'+current[1]).length > 0) {
        $('.elementor-tab-title').filter('#elementor-tab-title'+current[1]).click();
      }
    }, 200);
  }

  return {
    init: init,
  };
})(jQuery);

jQuery('document').ready(function () {
  CustomAccordionApp.init();
});
